import React,{Component} from 'react';
import "./header/Header.css" 
import "../scss/general.css"
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import 'react-month-picker-dropdown/dist/index.css'; 
import '../scss/green-theme.css';
import ReactToPdf from "react-to-pdf";
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
import ModalLogin from './ModalLogin';
import Mymodal from './modal';
import config from '../config';
//import "../config";
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
export default class Leave extends Component{
    constructor(props)
    {
        super(props);
        this.state=
        { 
            input:{},
            myitems:[],
            leavedata:{},
            tLeave:0,
            isLoaded: false,
            isData: false,
            ErrMsg2:"",
            ErrMsg:<img src={logo} alt=""/>
        };
    }
    cur(num) 
    {
        if(typeof num === "undefined"){num=0;}
        let cnum=parseFloat(num, 1);
        if(cnum > 0)
            return Number(num).toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    componentDidMount()
    {
        if(cookies.get("LoginID"))
        {
            document.body.style.cursor="wait";
            let input=this.state.input;
            let contract_year=cookies.get("contract_year");
            input["ID"]=cookies.get("LoginID");

            this.setState({input, isLoaded: false});
            axios.all([
                axios({
                  method: 'post',
                  url: cookies.get("phpclass")+'/index.php/user/get_leave/'+input["ID"],
    //              data: input["ID"],
                  headers: {'Content-Type': 'multipart/form-data'}
                  }),
                  axios({
                    method: 'post',
                    url: cookies.get("phpclass")+'/index.php/user/leave/'+input["ID"],
                    headers: {'Content-Type': 'multipart/form-data'}
                    })
                ])
                .then(axios.spread((response,res2) => {  
                if(response.data !=="1")
                {
                    document.body.style.cursor="default";
                    let leavedata=this.state.leavedata;
                    leavedata["BFAnnual"]=Number(response.data[0].BF_ANNUAL);
                    leavedata["BFCasual"]=0; //response.data[0].BF_CASUAL;
                    leavedata["BFSick"]=0; //response.data[0].BF_SICK;

                    leavedata["Annual"]=Number(response.data[0].ANNUAL);
                    leavedata["Casual"]=Number(response.data[0].CASUAL);
                    leavedata["Sick"]=Number(response.data[0].SICK);

                    leavedata["BAnnual"]=Number(response.data[0].ANNUAL)+Number(response.data[0].BF_ANNUAL);
                    leavedata["BCasual"]=Number(response.data[0].CASUAL);
                    leavedata["BSick"]=Number(response.data[0].SICK);

                    leavedata["EAnnual"]=Number(response.data[0].E_ANNUAL);
                    leavedata["ECasual"]=Number(response.data[0].E_CASUAL);
                    leavedata["ESick"]= Number(response.data[0].E_SICK);
                    leavedata["LAnnual"]=Number(response.data[0].L_ANNUAL);
                    leavedata["LCasual"]=Number(response.data[0].L_CASUAL);
                    leavedata["LSick"]=Number(response.data[0].L_SICK);
                    this.setState({tLeave:leavedata["LAnnual"]+leavedata["LCasual"]+leavedata["LSick"]});
                    leavedata["TAnnual"]=Number(response.data[0].BF_ANNUAL)+Number(response.data[0].ANNUAL)-Number(response.data[0].E_ANNUAL)-Number(response.data[0].L_ANNUAL);
                    leavedata["TCasual"]=Number(response.data[0].CASUAL)-Number(response.data[0].E_CASUAL)-Number(response.data[0].L_CASUAL);
                    leavedata["TSick"]=Number(response.data[0].SICK)-Number(response.data[0].E_SICK)-Number(response.data[0].L_SICK);
                    this.setState({leavedata,isLoaded: true,myitems: res2.data,tLeave:1,ErrMsg:""});
                }
                else
                  this.setState({ErrMsg:"",isLoaded:true});
            }))
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg2:<Mymodal Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });  
        }
        else
        {
           this.setState({ErrMsg2:<ModalLogin />});
        }    
    }
    render()
    {
      let isLoaded = this.state.isLoaded;
      let items = this.state.myitems;
      let fileName=this.state.input["ID"]+"-Leave.pdf";      
      if(isLoaded)
      {
        return( 
            <div className="container1">
                <div style={{width:"100%",paddingTop:"40px",textAlign:"center"}} >
                <br></br><br></br>
                <div className="inner-profile">
                <div style={{ width:"700px", marginLeft:"50%", margin:"0 auto"}} id="DReport" name="DReport"  ref={ref}>

{/*}                    <table style={{ width:"700px", marginLeft:"50%", margin:"0 auto"}} id="DReport" name="DReport"  ref={ref}>
                    <tbody>
        <tr >*/}
                        <div style={{width:"100%", textAlign:"center"}}>
                            <span className="box-title">Leave Balances & Details</span>
                                    <table syle={{width:"100%", margin:"auto"}}>
                                        <thead>
                                            <tr className="tr">
                                                <th className="th" scope="col"></th>
                                                <th className="th" scope="col">ANNUAL</th>
                                                <th className="th" scope="col">CASUAL</th>
                                                <th className="th" scope="col">SICK</th>
                                                <th className="th" scope="col">TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr >
                                            <td className="tddesc"  >Balance B/F</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["BFAnnual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["BFCasual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["BFSick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["BFSick"])+Number(this.state.leavedata["BFCasual"])+Number(this.state.leavedata["BFAnnual"]))}</td>
                                        </tr>
                                        <tr >
                                            <td className="tddesc" >This year</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["Annual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["Casual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["Sick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["Sick"])+Number(this.state.leavedata["Casual"])+Number(this.state.leavedata["Annual"]))}</td>
                                        </tr>
                                        <tr >
                                            <td className="tdhead" ><b>Balance</b></td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["BAnnual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["BCasual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["BSick"])}</td>
                                            <td className="tdambhead" >{this.cur(Number(this.state.leavedata["BSick"])+Number(this.state.leavedata["BCasual"])+Number(this.state.leavedata["BAnnual"]))}</td>
                                        </tr>
                                        <tr>
                                            <td className="tddesc" >Leave Encashed</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["EAnnual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["ECasual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["ESick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["ESick"])+Number(this.state.leavedata["ECasual"])+Number(this.state.leavedata["EAnnual"]))}</td>
                                        </tr>
                                        <tr>
                                            <td className="tddesc" >Leaves</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["LAnnual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["LCasual"])}</td>
                                            <td className="tdamb" >{this.cur(this.state.leavedata["LSick"])}</td>
                                            <td className="tdamb" >{this.cur(Number(this.state.leavedata["LSick"])+Number(this.state.leavedata["LCasual"])+Number(this.state.leavedata["LAnnual"]))}</td>
                                        </tr>
                                        <tr>
                                            <td className="tdhead" ><b>Balance C/F</b> </td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["TAnnual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["TCasual"])}</td>
                                            <td className="tdambhead" >{this.cur(this.state.leavedata["TSick"])}</td>
                                            <td className="tdambhead" >{this.cur(Number(this.state.leavedata["TSick"])+Number(this.state.leavedata["TCasual"])+Number(this.state.leavedata["TAnnual"]))}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <br></br>
                                    <div>
                                    <h5>Leave Detail</h5>
                                    <table style={{width:"100%",align:"center"}}>
                                        <thead >
                                            <tr className="tr">
                                                <th className="th" colSpan="3" scope="col">Leave Period</th>
                                                <th className="th" scope="col">Annual</th>
                                                <th className="th" scope="col">Casual</th>
                                                <th className="th" scope="col">Sick</th>
                                                <th className="th" scope="col">LWP</th>
                                                <th className="th" scope="col">Comp.</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            
                                            {items.map((result ,i) => {
                                                
                                            return (
                                                <tr className="trc" key={i}>
                                                    <td className="tdamcenter-1" colSpan="3" >{Moment(result.LEAVE_FROM).format("DD/MM/YYYY")} - {Moment(result.LEAVE_TO).format("DD/MM/YYYY")}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LANNUAL)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LCASUAL)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LSICK)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.LWP)}</td>
                                                    <td className="tdamcenter" >{this.cur(result.Compensatory)}</td>
                                                </tr>
                                            )})
                                            }
                                        
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
{/*}                            </tr>
                            </tbody>
                                        </table>*/}
                            </div>
                                    <br></br>
                                   <div style={{textAlign:"center",width:"100%"}}>
                                          <ReactToPdf targetRef={ref} filename={fileName} x={15} y={15}>
                                          {({toPdf}) => (
                                            <button onClick={toPdf} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                                            )}
                                            </ReactToPdf>
                                    </div>
                                </div>
                            </div>
                            <br></br>
                            <div className="center">
                                {this.state.ErrMsg2}
                            </div>
                        </div>
        );    
    }
    else
    {
        return(
            <div className="container1">
                <div className="center">
                    {this.state.ErrMsg}
                </div>
            </div>
        );
    }
    }
}